import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#ffffff',
                secondary: '#6f5248',
                anchor: '#8c9eff',
            },
        },
    },
});
